import axios from 'axios'
import { getBuisnessToken } from '@/libs/util'
import router from '@/router'
import Qs from 'qs'
import ViewUI from 'view-design'
import Vue from 'vue'
Vue.use(ViewUI)
class HttpRequest {
  constructor(baseUrl = process.env.VUE_APP_SERVER_DOMAIN) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig() {
    const buisnessToken = getBuisnessToken();
    const config = {
      baseURL: this.baseUrl,
      headers: {
        // "Content-Type" : "application/x-www-form-urlencoded",
        "blade-auth": buisnessToken,
        // system:"companyAdmin"
      },
      // withCredentials: true
    }
    return config
  }
  getInsideConfigAdd() {
    const buisnessToken = getBuisnessToken();
    const config = {
      baseURL: this.baseUrl,
      headers: {
        // 'bearer ' +
        "blade-auth": buisnessToken,
        // system:"companyAdmin"
      },
      // withCredentials: true
    }
    return config
  }
  getInsideConfigUp() {
    const buisnessToken = getBuisnessToken();
    const config = {
      baseURL: this.baseUrl,
      headers: {
        "Content-Type": "multipart/form-data",
        "blade-auth": buisnessToken,
        // system:"companyAdmin"
      },
      // withCredentials: true
    }
    return config
  }
  getInsideConfigDown() {
    const buisnessToken = getBuisnessToken();
    const config = {
      baseURL: this.baseUrl,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "blade-auth": buisnessToken,
        // system:"companyAdmin"
      },
      responseType: 'blob',
      // withCredentials: true
    }
    return config
  }
  requestDown(url, data, method) {
    let options = this.getInsideConfigDown();
    options.method = method;
    options.url = url;
    options.data = data;
    method = method.toLowerCase();
    if (method === 'get') {
      options.params = data;
    }
    return new Promise((resolve, reject) => {
      axios(options).then(res => {
        if (res.data.code == -1) {
          router.push({ name: 'Login' })
        } else {
          //成功
          resolve(res)
        }
      }).catch(res => {
        //失败
        reject(res)
      })
    })
  }
  postDown(url, data = {}) {
    let options = this.getInsideConfigDown();
    options.url = url;
    options.data = Qs.stringify(data);
    options.method = 'post';
    return new Promise((resolve, reject) => {
      axios(options).then((res) => {
        if (res.data.code == -1) {
          router.push({ name: 'Login' })
        } else {
          //成功
          resolve(res)
        }
      }).catch(res => {
        //失败
        reject(res)
      });
    })
  }
  request(url, data, method) {
    // data._isback = 1;
    // if (typeof buisnessToken === 'string') {
    //   data.token = buisnessToken;
    // }
    let options = this.getInsideConfig();
    options.method = method;
    options.url = url;
    if (method === 'get' || method === 'delete') {
      options.params = data;
    } else {
      // options.data =  Qs.stringify(data);
    }
    options.data = Qs.stringify(data);
    method = method.toLowerCase();
    return new Promise((resolve, reject) => {
      axios(options).then(res => {
        if (res.data.code == -1) {
          router.push({ name: 'Login' })
        } else {
          //成功
          resolve(res.data)
        }
      }).catch(res => {
        //失败
        Vue.prototype.$Message.error('服务器请求失败');
        reject(res)
      })
    })
  }
  get(url, data = {}) {
    return this.request(url, data, 'get');
  }
  post(url, data = {}) {
    return this.request(url, data, 'post');
  }
  put(url, data = {}) {
    return this.request(url, data, 'put');
  }
  delete(url, data = {}) {
    return this.request(url, data, 'delete');
  }
  request1(url, data, method) {
    let options = this.getInsideConfigAdd();
    options.method = method;
    options.url = url;
    options.data = data;
    method = method.toLowerCase();
    if (method === 'get') {
      options.params = data;
    }
    return new Promise((resolve, reject) => {
      axios(options).then(res => {
        if (res.data.code == -1) {
          router.push({ name: 'Login' })
        } else {
          //成功
          resolve(res.data)
        }
      }).catch(res => {
        //失败
        Vue.prototype.$Message.error('服务器请求失败');
        reject(res)
      })
    })
  }
  getjson(url, data = {}) {
    return this.request1(url, data, 'get');
  }
  postjson(url, data = {}) {
    return this.request1(url, data, 'post');
  }
  request2(url, data, method) {
    let options = this.getInsideConfigUp();
    options.method = method;
    options.url = url;
    options.data = data;
    method = method.toLowerCase();
    return new Promise((resolve, reject) => {
      axios(options).then(res => {
        if (res.data.code == -1) {
          router.push({ name: 'Login' })
        } else {
          //成功
          resolve(res.data)
        }
      }).catch(res => {
        //失败
        Vue.prototype.$Message.error('服务器请求失败');
        reject(res)
      })
    })
  }
  buffer(url) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer',
      }).then(data => {
        resolve(data.data)
      }).catch(error => {
        reject(error.toString())
      })
    })
  }
  postUp(url, data = {}) {
    return this.request2(url, data, 'post');
  }
}
export default HttpRequest
